const {
    NATIONAL_DOCUMENT,
    PASSPORT_DOCUMENT
} = require('../constants/documentGroups')

const {
    DOCUMENT_DA,
    DOCUMENT_PA
} = require('../constants/documentCodes')

module.exports = {
    lengthId: [9],
    lengthPassport: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    lengthResident: 0,
    patternId: "^[a-np-zA-NP-Z0-9]{9}$",
    patternPassport: "^[a-zA-Z0-9]{4,15}$",
    patternResident: "",
    isValidNationalAlgorith: () => { return true },
    isValidPassportAlgorith: () => { return true },
    isValidResidentAlgorith: () => { return true },
    documentGroupMap: {
        [NATIONAL_DOCUMENT] : [DOCUMENT_DA],
        [PASSPORT_DOCUMENT] : [DOCUMENT_PA]
    }
}